import React, { Component } from "react";
import TranslationView from "../../../../../../components/Translation/TranslationView";
import PriceBreakdownViewProps from "./PriceBreakdownViewProps";
import PriceBreakdownViewStyle from "./PriceBreakdownViewStyle";

export default class PriceBreakdownView extends Component<PriceBreakdownViewProps> {

    private _style = new PriceBreakdownViewStyle();

    render() {
        const { label, amount, style } = this.props;
        return (
            <div style={this._style.category}>
                <TranslationView style={this._style.label}>
                    {label}
                </TranslationView>

                <span style={{ ...this._style.amount, ...style }}>
                    €{amount}
                </span>
            </div>
        );
    }
}